import React from "react";

const Courier = () => {
  return <p className="text-center p-3 m-3">coming soon!</p>;
};

export default Courier;
